import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { forkJoin, Observable, of, Subject, timer } from 'rxjs';
import { catchError, first, switchMap, takeUntil } from 'rxjs/operators';

import { TranslateService } from '@ngx-translate/core';

import { OpenAPIService } from '../../../services/openAPI.service';

const INTERVAL = 1000;

@Component({
  selector: 'send-photo-ai',
  templateUrl: './send-photo-ai.component.html',
  styleUrls: [
    './send-photo-ai.component.scss'
  ]
})
export class SendPhotoAiComponent implements OnInit, OnDestroy {

  @Input() id: any = null;
  @Input() photoPlaceholder: string | null = null;
  
  @Output() onClick = new EventEmitter<any>();
  @Output() onError = new EventEmitter<any>();
  @Output() onProcessed = new EventEmitter<any>();

  photo: any = null;
  spin: boolean = true;
  spinAi: boolean = true;

  imageUrl: string | null = null;
  imageUrlBackground: string | null = null;

  _polling: boolean = false;
  closeTimer$ = new Subject<any>();

  status: any = {
    preprocessing: { label: 'APP.STATUS.VISIT.preprocessing', background: '#7F8C8D', border: '#7F8C8D', color: '#FFFFFF' },
    processing: { label: "APP.STATUS.VISIT.processing", background: '#E87823', border: '#E87823', color: '#ffffff' },
    processed: { label: 'APP.STATUS.VISIT.processed', background: '#25AC6F', border: '#25AC6F', color: '#ffffff' }
  };

  photoStatus: any = {
    not_ready: { label: 'APP.STATUS.PHOTO.not_ready', background: '#7F8C8D', border: '#7F8C8D', color: '#FFFFFF', icon: 'ellipsis-horizontal-outline', iconColor: 'medium' },
    ready: { label: "APP.STATUS.PHOTO.ready", background: '#93efc6', border: '#93efc6', color: '#333333', icon: 'ellipse-outline', iconColor: 'primary' },
    pending: { label: 'APP.STATUS.PHOTO.pending', background: '#E87823', border: '#E87823', color: '#ffffff', icon: 'cog-outline', iconColor: 'warning' },
    processed: { label: 'APP.STATUS.PHOTO.processed', background: '#25AC6F', border: '#25AC6F', color: '#ffffff', icon: 'checkmark-outline', iconColor: 'success' },
    refused: { label: 'APP.STATUS.PHOTO.refused', background: '#ea2828', border: '#ea2828', color: '#ffffff', icon: 'remove-circle-outline', iconColor: 'danger' },
  };

  error: boolean = false;
  errorMessage: string | null = null;

  constructor(
    private translate: TranslateService,
    private apiService: OpenAPIService
  ) { }

  ngOnInit() {
    this._loadMedicalPhoto(this.id);
  }

  ngOnDestroy() {
    this.closeTimer$.next(true);
  }

  _onClick() {
    this.onClick.emit(this.photo);
  }

  _loadMedicalPhoto(id: number) {
    this.spin = true;
    this.apiService.getDetails('medicalphotos', id).subscribe({
      next: (response: any) => {
        this.photo = { ...response.data };
        const _mimeType = this.photo.mime_type || 'image/jpeg';
        this.imageUrl = `data:${_mimeType};base64,${this.photo.image}`;
        this.imageUrlBackground = `url('data:${_mimeType};base64,${this.photo.image}')`;
        this.spin = false;
        this.sendPhotoToAI();
      },
      error: (error: any) => {
        console.log('_loadMedicalPhoto error', error);
        this.spin = false;
      }
    });
  }

  getRandomInt(max) {
    const random = Math.floor(Math.random() * max);
    // console.log('getRandomInt', max, random);
    return random;
  }
  
  sendPhotoToAI() {
    this.spinAi = true;
    // setTimeout(() => {
    //   this.spinAi = false;
    //   this.onProcessed.emit(this.photo);
    // }, this.getRandomInt(10000));

    // this.patientsService.sendPhotoToAI(this.id).pipe(first()).subscribe(
    this.apiService.saveElement(`medicalphotos/ai_analysis_req/${this.id}`, {}).subscribe({
      next: (response: any) => {
        this.photo = { ...response.data };
        this._startPollingAI();
        this.spinAi = false;
      },
      error: (error: any) => {
        this.spinAi = false;
        console.log('sendPhotoToAI error', error);
        this.error = true;
        this.errorMessage = error.error.message;
        this.onError.emit({error: error, photo: this.photo});
      }
    });
  }

  _startPollingAI() {
    this._polling = true;
    timer(0, INTERVAL).pipe(
      switchMap(() => this._loadMedicalPhotoAI()),
      takeUntil(this.closeTimer$)
    ).subscribe({
      next: (response: any) => {
        if (response && response.data && response.data.ai_result) {
          this.closeTimer$.next(true);
          this._polling = false;
          this.onProcessed.emit(this.photo);
          // this.photo = { ...response.data };
          // this._hasManualEvaluation = this._isManualEvaluation();
          // this._updateModel();
          // this._updated(this.photo);
        }
      },
      error: (error: any) => {
        this._polling = false;
        this.error = true;
        this.errorMessage = error.error.message;
        this.onError.emit({error: error, photo: this.photo});
        console.log('error', error);
      }
    });
  }

  _loadMedicalPhotoAI(): Observable<any> {
    return this.apiService.getDetails('medicalphotos', this.id);
  }

  isNotReady(photo: any) {
    return photo && photo.photo_status === 'not_ready';
  }

  getPhotoColor(photo: any) {
    if (photo) {
      switch (photo.photo_status) {
        case 'not_ready':
          return 'medium';
        case 'ready':
          return 'primary';
        case 'processing':
          return 'warning';
        case 'processed':
          return 'primary';
        default:
      }
    }
    return 'medium';
  }
}
